require('./mortgageRequestMortgageDenialView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { formatText } = require('core/i18n').i18n;
// @ components
const MortgageRequestCover = require('components/mortgageRequest/mortgageRequestCover/mortgageRequestCover');
const MortgageRequestHeader = require('components/mortgageRequest/mortgageRequestHeader/mortgageRequestHeader');
const { MortgageRequestMortgageDenial } = require('components/mortgageRequest/mortgageRequestMortgageDenial/mortgageRequestMortgageDenial');

const MortgageRequestMortgageDenialView = props => {
    const { immGlobalPosition } = props;
    const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
    const mappingBreadcrumb = [
        {
            text: formatText('navbar-loans'),
            url: '/myprofile/loans-mortgages'
        },
        {
            text: formatText('mortgageRequestPresentation-title'),
            url: '/myprofile/mortgage'
        }
    ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

    return (
        <div className="mortgage-request-mortgage-denial-view">
            <MortgageRequestCover>
                <MortgageRequestHeader breadcrumbConfig={mappingBreadcrumb}
                    titleKey="mortgageRequestCommons-denialTitle">
                </MortgageRequestHeader>
            </MortgageRequestCover>
            <div className="mortgage-request-mortgage-denial-view__body">
                <MortgageRequestMortgageDenial />
            </div>
        </div>
    );
};

MortgageRequestMortgageDenialView.propTypes = {
    immGlobalPosition: PropTypes.object.isRequired
}

module.exports.MortgageRequestMortgageDenialView = connect(
    state => ({
        immGlobalPosition: state.globalPosition,
    }), null
)(MortgageRequestMortgageDenialView);
